let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iiqDR"), load("dUKeO"), load("kDLrp")]).then(() => parcelRequire('6as51'));